export default "__VITE_ASSET__CPe7qeMG__"